import { useEffect } from "react";

import { getVariables } from "Reducers/project/settings/variable";
import { useAppDispatch, useAppSelector } from "Store/hooks";

export function useLoadVariables({
  organizationId,
  projectId
}: {
  organizationId: string;
  projectId: string;
}) {
  const dispatch = useAppDispatch();
  const projectVariable = useAppSelector(
    ({ projectVariable }) => projectVariable || {}
  );
  const variables = Object.values(
    projectVariable.data?.[organizationId]?.[projectId] || {}
  );

  useEffect(() => {
    dispatch(getVariables({ organizationId, projectId }));
  }, [projectId, dispatch, organizationId]);
  return {
    loading: projectVariable.loading,
    errors: projectVariable.errors,
    status: projectVariable.status,
    variables
  };
}
